import { createContext, Dispatch, useContext } from 'react';

import { ToastValues } from './ToastValues';

export const ToastDispatchContext = createContext<Dispatch<ToastValues | undefined> | undefined>(
  undefined,
);

export function useToastDispatchContext() {
  return useContext(ToastDispatchContext);
}
